import { _,moment } from '../../../../vendor'

import { Biscuit } from '../../../utils'

import InboomaBaseCollectionView from '../../InboomaBaseCollectionView'
import InboomaBaseView from '../../InboomaBaseView'
import InboomaBaseModel from '../../../models/InboomaBaseModel'

import PaymentAccountItemTpl from '../../../templates/myInbooma/PaymentAccountItemTpl.html'

const PaymentAccountsItemView = InboomaBaseView.extend({

    template : PaymentAccountItemTpl,
    className : 'inb-c-item inb-payment-account-item',

    ui: {
        dropdown: '.inb-dropdown',
        accountRemove: '.inb-account__remove'
    },

    events: {
        'click @ui.accountRemove' : '_removeAccount'
    },

    templateContext : {
        moment
    },

    _removeAccount () {
        // Lately this was NOT working :(

        if (confirm(this.t('really_remove'))) {
      
            const that = this;

            const DeleteAccount = InboomaBaseModel.extend({
                urlRoot : '/connects/deleteStripeBankAccount'
            });

            const deleteAccount = new DeleteAccount();

            deleteAccount.save(
                { 
                    client_id : Biscuit.get('user.client_id')
                },
                {
                    success (model, response) {
                        console.log('S', model, response);
                    },
                    error (model, response) {
                        console.log('E', model, response);
                    }
                }
            );

            new Notification({
                message : that.t('removed_${a}',{a:that.t('reservation')}),
                duration : 5000,
                closeable : true,
                icon : 'fi fi-check'
              });
  
            that.render(); 
        }

        return false;
    },

    onRender () {

        const dd = this.getUI('dropdown');

        setTimeout(function() {
            new Foundation.Dropdown(dd);
        }, 0);
    
    },

});

const a = '${a}';

export default InboomaBaseCollectionView.extend({

    el : '#inb-c-main .off-canvas-wrapper',
    template : `
        <div class="medium-4 column">
            <h4><%= t('payment_accounts') %></h4>

            <div class="inb-finances-accounts-list">
                <!-- PaymentAccountsItemView -->
            </div>
        
            <% if (collection.models.length === 0) { %>
            <!-- Could also be realized via InboomaBaseCollectionView.emptyView -->
            <div class="inb-payment-account-item add-payment-account text-center">
                <a href="finances/paymentAccountForm">
                    <h2>+</h2>
                    <h5><%= t('add_${a}', { a:t('account') }) %></h5>
                </a>
            </div>
            <% } %>
        </div>

        <style type="text/css">
        #inb-c-sidebar, #inb-c-main-sort-nav { display:none; }
        </style>
    `,
    templateContext () {
        return {
            collection : this.collection
        }
    },
    childView : PaymentAccountsItemView,
    childViewContainer : '.inb-finances-accounts-list',

    _checkForEmptyCollection: _.noop,

    initialize () {
        this.render();
    },

});